export default __webpack_public_path__ + "static/media/success-image-nsaa.1e82a3e3.svg";